<template>
    <section ref="section7" class="mx-auto flex h-full flex-col">
        <v-register-head
            @previous="6"
            :step="7"
            :landing-route="registrationProcessData.routes.landing"
        ></v-register-head>
        <div
            class="flex h-full flex-col items-center justify-between px-4 py-8 md:px-12"
        >
            <form
                method="POST"
                :action="registrationProcessData.routes.processPersonalData"
                id="setup-personal-data-form"
            >
                <v-csrf-token></v-csrf-token>
                <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                    <figure class="flex gap-3">
                        <div><v-icon icon="id" size="8"></v-icon></div>
                        <div class="flex flex-col justify-center">
                            <div class="mb-3 text-heading-3-desktop">
                                Izpolnite svoje osebne podatke
                            </div>
                            <div class="text-body-regular text-black-40">
                                Želimo si vas bolje spoznati
                            </div>
                        </div>
                    </figure>
                    <figure class="flex flex-col gap-4 lg:gap-8">
                        <div>
                            <v-select
                                class="v-select--xs w-full appearance-none rounded-full border-0 p-0 font-medium text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green"
                                :options="customerFormEnums.title"
                                placeholder="Naziv *"
                                v-model="customerPrefix"
                                label="label"
                                ref="prefix"
                                id="prefix"
                                :name="'prefix'"
                            >
                                <template v-slot:no-options>
                                    Za ta iskalni niz ni zadetkov.
                                </template>
                            </v-select>
                            <input
                                type="hidden"
                                name="title"
                                :value="
                                    customerPrefix == null
                                        ? ''
                                        : customerPrefix.value
                                "
                            />
                            <template v-if="validationErrors.title">
                                <label class="small-text-medium text-red-500">{{
                                    validationErrors.title[0] ?? ""
                                }}</label>
                            </template>
                        </div>
                        <div>
                            <v-select
                                class="v-select--xs w-full appearance-none rounded-full border-0 p-0 font-medium text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green"
                                :options="customerFormEnums.professional_title"
                                placeholder="Strokovni naziv *"
                                v-model="customerProfessionalTitle"
                                label="label"
                                ref="prefix"
                                id="prefix"
                                :name="'prefix'"
                            >
                                <template v-slot:no-options>
                                    Za ta iskalni niz ni zadetkov.
                                </template>
                            </v-select>
                            <input
                                type="hidden"
                                name="professional_title"
                                :value="
                                    customerProfessionalTitle == null
                                        ? ''
                                        : customerProfessionalTitle.value
                                "
                            />
                            <template v-if="validationErrors.professional_title">
                                <label class="small-text-medium text-red-500">{{
                                    validationErrors.professional_title[0] ?? ""
                                }}</label>
                            </template>
                        </div>
                        <div>
                            <v-form-input
                                id="userFirstName"
                                label="Ime"
                                type="text"
                                :value="this.old.name ?? (this.user.name ?? '')"
                                name="name"
                                required="true"
                            ></v-form-input>
                            <template v-if="validationErrors.name">
                                <label class="small-text-medium text-red-500">{{
                                    validationErrors.name[0] ?? ""
                                }}</label>
                            </template>
                        </div>
                        <div>
                            <v-form-input
                                id="userLastName"
                                label="Priimek"
                                type="text"
                                :value="this.old.last_name ?? (this.user.last_name ?? '')"
                                name="last_name"
                                required="true"
                            ></v-form-input>
                            <template v-if="validationErrors.last_name">
                                <label class="small-text-medium text-red-500">{{
                                    validationErrors.last_name[0] ?? ""
                                }}</label>
                            </template>
                        </div>
                        <div>
                            <v-datepicker
                                v-model="birth_date"
                                :formatter="dateFormatter"
                                id="userBirth"
                                name="birth_date"
                                placeholder="Datum rojstva"
                                as-single
                                input-classes="block w-full appearance-none rounded-full border-0 p-0 text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green px-5 py-4 text-form"
                            />
                            <template v-if="validationErrors.birth_date">
                                <label class="small-text-medium text-red-500">{{
                                    validationErrors.birth_date[0] ?? ""
                                }}</label>
                            </template>
                        </div>
                        <div class="text-body-regular text-black-40">
                            Vaše osebne podatke lahko kasneje urejate na vašem
                            profilu
                        </div>
                    </figure>
                </figure>
            </form>
        </div>
        <div
            class="flex h-full max-h-[102px] justify-between border-t px-4 pt-4"
        >
            <div class="flex w-full justify-center">
                <a
                    @click="submitForm('setup-personal-data-form')"
                    class="button button--form"
                >
                    <label class="text-small-text-medium">Nadaljujte</label>
                    <v-icon icon="arrow-right" size="4"></v-icon>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import VueTailwindDatepicker from "vue-tailwind-datepicker";
export default {
    components: {
        "v-datepicker": VueTailwindDatepicker,
    },
    props: {
        registrationProcessData: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        customerFormEnums: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        old: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            customerPrefix: null,
            customerProfessionalTitle: null,
            birth_date: null,
            dateFormatter: {
                date: "D.M.YYYY",
                month: "MMM",
            },
        };
    },
    computed: {},
    mounted() {
        this.birth_date = this.old.birth_date ? this.old.birth_date : "";
        if(this.old && 'title' in this.old) {
            this.customerFormEnums.title.forEach((element) => {
                if(this.old.title == element.value) {
                    this.customerPrefix = element;
                }
            })
        }
        if(this.old && 'professional_title' in this.old) {
            this.customerFormEnums.professional_title.forEach((element) => {
                if(this.old.professional_title == element.value) {
                    this.customerProfessionalTitle = element;
                }
            })
        }
    },
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
